import React from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';

//HELPERS
import * as c from '../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../store/campanha';
import { listaAction } from '../store/lista';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import Error404 from './error404';
import Templates from '../components/carimboTempo/templates/template.js';
import TemplatesSMS from '../components/carimboTempo/templates/templateSMS.js';
import ListaLaudo from '../components/carimboTempo/downloadLaudo.js';
import AgendamentoDownload from '../components/carimboTempo/agendamentoDownload.js';
import AgendamentoUpload from '../components/carimboTempo/agendamentoUpload.js';
import EnvioToi from '../components/carimboTempo/envioToi';
import listaCelularUpload from '../components/carimboTempo/listaCelularUpload';
import MonitoramentoMailing from '../components/carimboTempo/monitoramentoMailing';
import enviopartes from '../components/carimboTempo/enviopartes';
import AnexosUpload from '../components/carimboTempo/anexosUpload';
import envioUnico from '../components/carimboTempo/envioUnico';

class Carimbo extends React.PureComponent
{
    constructor(props)
    {
        super(props);
    }


    render()
    {
        return (            
            <PrivateLayout navActiveItem={c.NAV_STAMP}>

                <Switch history={this.props.history}>                

                    <Route exact path={c.STAMP_ROUTE + "/templates"} component={Templates} />
                    <Route exact path={c.STAMP_ROUTE + "/templatesSMS"} component={TemplatesSMS} />
                    <Route exact path={c.STAMP_ROUTE + "/listaCelularUpload"} component={listaCelularUpload} />
                    <Route exact path={c.STAMP_ROUTE + "/monitoramentoMailing"} component={MonitoramentoMailing} />
                    <Route exact path={c.STAMP_ROUTE + "/envio-toi"} component={EnvioToi} />
                    <Route exact path={c.STAMP_ROUTE + "/laudo-download"} component={ListaLaudo} /> 
                    <Route exact path={c.STAMP_ROUTE + "/upload-toi"} component={EnvioToi} />
                    <Route exact path={c.STAMP_ROUTE + "/upload-partes"} component={enviopartes} />
                    <Route exact path={c.STAMP_ROUTE + "/status-mailing"} component={MonitoramentoMailing} />
                    <Route exact path={c.STAMP_ROUTE + "/agendamento"} component={AgendamentoDownload} />
                    <Route exact path={c.STAMP_ROUTE + "/agendamento-upload"} component={AgendamentoUpload} />
                    <Route exact path={c.STAMP_ROUTE + "/anexos-upload"} component={AnexosUpload} />    
                    <Route exact path={c.STAMP_ROUTE + "/envioUnico"} component={envioUnico} />    
                    <Route component={Error404} />     

                </Switch>

            </PrivateLayout>
        );
    }  
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha, lista: state.lista };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch), lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Carimbo));
